import { motion } from "framer-motion";
import { Gauge, TrendingDown, Clock, Target, Quote } from "lucide-react";

const stats = [
    {
        icon: Gauge,
        value: "3.4×",
        label: "faster decision cycles",
        sub: "from weekly reviews to real-time signals",
        accent: "text-cyan-300",
        ring: "from-cyan-400/30 to-cyan-400/0",
    },
    {
        icon: TrendingDown,
        value: "−89%",
        label: "tool sprawl",
        sub: "57+ subscriptions consolidated into one",
        accent: "text-emerald-300",
        ring: "from-emerald-400/30 to-emerald-400/0",
    },
    {
        icon: Clock,
        value: "−76%",
        label: "time spent reporting",
        sub: "leadership reclaims 11h / week on average",
        accent: "text-amber-glow",
        ring: "from-amber-400/30 to-amber-400/0",
    },
    {
        icon: Target,
        value: "+42%",
        label: "forecast accuracy",
        sub: "pipeline tied directly to delivery & cash",
        accent: "text-violet-300",
        ring: "from-violet-400/30 to-violet-400/0",
    },
];

export const Outcomes = () => {
    return (
        <section
            id="outcomes"
            className="relative py-24 sm:py-32 overflow-hidden"
            data-testid="outcomes-section"
        >
            <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
            <div className="absolute inset-0 grid-bg opacity-[0.18] pointer-events-none" />

            <div className="relative max-w-7xl mx-auto px-6 sm:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-14">
                    <div className="lg:col-span-7">
                        <p className="font-code text-xs uppercase tracking-[0.25em] text-electric font-semibold mb-4">
                            // outcomes · not features
                        </p>
                        <h2 className="font-outfit text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white leading-[1.05]">
                            What changes when chaos
                            <br />
                            <span className="gradient-text">
                                becomes a system.
                            </span>
                        </h2>
                    </div>
                    <p className="lg:col-span-5 text-zinc-400 text-base sm:text-lg leading-relaxed font-light">
                        Aggregated outcomes from IT companies running ApexBrain
                        as their operating layer. Numbers are blended cohort
                        averages from teams of 20–250 over their first 6 months.
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-5">
                    {stats.map((s, i) => (
                        <motion.div
                            key={s.label}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-50px" }}
                            transition={{ duration: 0.5, delay: i * 0.07 }}
                            className="relative rounded-2xl border border-white/[0.06] bg-obsidian-200/70 backdrop-blur-sm p-6 overflow-hidden hover:border-white/15 transition-colors"
                            data-testid={`outcome-card-${i}`}
                        >
                            <div
                                className={`absolute -top-16 -right-16 w-40 h-40 rounded-full bg-gradient-to-br ${s.ring} blur-3xl pointer-events-none`}
                            />
                            <div className="relative flex items-start justify-between">
                                <div className="w-10 h-10 rounded-lg bg-white/[0.04] border border-white/[0.08] flex items-center justify-center">
                                    <s.icon className={`w-4 h-4 ${s.accent}`} />
                                </div>
                                <span className="font-code text-[10px] text-zinc-600 tabular-nums">
                                    metric_{String(i + 1).padStart(2, "0")}
                                </span>
                            </div>
                            <div className="relative mt-6">
                                <div
                                    className={`font-outfit text-4xl sm:text-5xl font-semibold tabular-nums tracking-tight ${s.accent}`}
                                >
                                    {s.value}
                                </div>
                                <div className="mt-3 font-outfit text-sm font-semibold text-white">
                                    {s.label}
                                </div>
                                <div className="mt-1.5 text-xs text-zinc-500 leading-relaxed">
                                    {s.sub}
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>

               
            </div>
        </section>
    );
};
